export default (): string => {
  const isStagingProduction = process.env.NODE_ENV === 'production';
  return `${isStagingProduction ? 'https://cdn.zapier.com/zapier/images' : ''}`;
};
